import { Fragment, ReactElement } from 'react';
import ResearchNotificationsCivilStatusRegistryOfficeShared from 'shell/components/shared/research-notifications-civil-status-registry-office/list';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchNotificationsCivilStatusRegistryOfficePage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchNotificationsCivilStatusRegistryOfficeShared scope={IdAmbito.Iscrizioni} />
    </Fragment>
  );
};

ResearchNotificationsCivilStatusRegistryOfficePage.displayName =
  'Research Notifications Civil Status Registry Office Page Subscription component';

export default ResearchNotificationsCivilStatusRegistryOfficePage;
